import { createStore, applyMiddleware, compose } from 'redux';
import { jwt } from '../middleware/jwt';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import rootReducer from '../reducers';
import createSagaMiddleware from 'redux-saga';

export const sagaDevMiddleware = createSagaMiddleware();
export function configureDevStore(preloadedState) {
    return createStore(
        rootReducer,
        preloadedState,
        compose(
            applyMiddleware(thunk, createLogger(), jwt, sagaDevMiddleware),
            window.devToolsExtension ? window.devToolsExtension() : f => f
        )
    );
}



// WEBPACK FOOTER //
// ./src/store/configureStore.dev.js